import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try {
      // eslint-disable-next-line no-console
      console.error("Screen error caught by ErrorBoundary:", error, info);
      // the component stack as plain text, so it survives log scrapers that don't expand objects
      // eslint-disable-next-line no-console
      console.error("ErrorBoundary component stack:" + ((info && info.componentStack) || " (none)"));
    } catch (e) {}
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "32px", fontFamily: "sans-serif", maxWidth: "680px", margin: "40px auto" }}>
          <h2 style={{ marginBottom: "8px" }}>This screen hit a problem</h2>
          <p style={{ color: "#555" }}>
            The rest of the app is fine — pick a screen to carry on:
          </p>
          <p style={{ fontSize: "16px", margin: "14px 0" }}>
            <a href="/partorders/">Part Orders</a>{"  ·  "}
            <a href="/jobs/">Jobs</a>{"  ·  "}
            <a href="/quotes/">Quotes</a>{"  ·  "}
            <a href="/invoicing/">Invoicing</a>{"  ·  "}
            <a href="/">Home</a>
          </p>
          <pre style={{ whiteSpace: "pre-wrap", color: "#b00", fontSize: "12px", marginTop: "16px" }}>
            {String(this.state.error && this.state.error.message)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
